import { useLang } from '@/i18n';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import O from './components/O';
import P from './components/P';
import Q from './components/Q';
import R from './components/R';

export default function IndexDynamic() {
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('offgrid');
    const { locale = '' } = useRouter();

    const obj: SideMenuProps = {
        items: [
            { text: t('fix_tab1'), link: '#off-grid-B' },
            { text: t('fix_tab2'), link: '#off-grid-C' },
            { text: t('fix_tab3'), link: '#off-grid-D' },
            { text: t('fix_tab4'), link: '#off-grid-F' },
            { text: t('fix_tab5'), link: '#off-grid-O' },
            { text: t('fix_tab6'), link: '#off-grid-P' },
            { text: t('fix_tab7'), link: '#off-grid-Q' },
            { text: t('fix_tab8'), link: '#off-grid-R' },
        ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <B />
            <C />
            <D />
            <E />
            <EmailSubscribe locale={locale} className="email-subscribe" pageType={PAGE_TYPE.OffGrid} entry_position={5} />
            <F />
            <O />
            <P />
            <Q />
            <R />
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
